import React from "react";

import * as Yup from "yup";
import { useForm } from "react-hook-form/dist/react-hook-form.ie11";

import {
  DeleteAreaConfirmationModalStateProviderProps,
  DeleteAreaFormFields,
} from "./types";
import DeleteAreaConfirmationModal from "./DeleteAreaConfirmationModal";

import { fireOnce } from "@ds-developer/frontend";
import { useTealium } from "@hubcapp/context";

const validationSchema = Yup.object().shape({
  confirmation: Yup.string()
    .test({
      name: "isDelete",
      test: value => /delete/i.test(value || ""),
    })
    .required(),
});

const StateProvider: React.FC<DeleteAreaConfirmationModalStateProviderProps> = ({
  handleOnDelete = () => {},
  onCancelClick,
  deleting = false,
  loading = false,
}) => {
  const {
    formState: { isValid },
    handleSubmit: onSubmit,
    register,
  } = useForm<DeleteAreaFormFields>({
    mode: "onChange",
    validationSchema,
  });

  const { trackEvent } = useTealium();

  const handleInputFieldEvent = () => {
    fireOnce(
      "Areas & prices - Edit My District|Interaction|Delete To Confirm",
      () => {
        trackEvent({
          eventCategory: "Areas & prices - Edit My District",
          eventAction: "Interaction",
          eventLabel: "Type Delete To Confirm",
        });
      },
    );
  };

  return (
    <DeleteAreaConfirmationModal
      onConfirmClick={onSubmit(handleOnDelete)}
      disabled={!isValid}
      register={register}
      loading={loading}
      submitting={deleting}
      onCancelClick={onCancelClick}
      handleInputFieldEvent={handleInputFieldEvent}
    />
  );
};

export default StateProvider;
